import { Check, Download, Users } from "lucide-react";
import { API } from "../data/site";
import { CATERING_NOTES, PACKAGES } from "../data/cateringPackages";
import { FadeUp, SectionHead } from "./Motion";

const pick = (p) => {
  localStorage.setItem("sde_package", `Package ${p.n} — Tray Orders ($${p.price}/person, min ${p.minGuests} guests)`);
  window.location.hash = "#catering";
};

const PackageCard = ({ p, delay }) => (
  <FadeUp delay={delay} className="h-full">
    <div
      data-testid={`package-card-${p.n}`}
      className={`flex h-full flex-col rounded-2xl border p-8 transition-transform duration-500 hover:-translate-y-1.5 md:p-9 ${
        p.featured ? "border-gold/60 bg-gold/[0.06]" : "border-white/10 bg-surface/40"
      }`}
    >
      <div className="flex items-start justify-between">
        <span className={`font-serif text-6xl ${p.featured ? "text-gold" : "text-white/15"}`}>{String(p.n).padStart(2, "0")}</span>
        <span className="rounded-full border border-gold/40 px-3 py-1 text-[10px] uppercase tracking-[0.18em] text-gold">{p.tray}</span>
      </div>
      <div className="mt-6 flex items-baseline gap-2">
        <span className="font-serif text-5xl text-gold">${p.price}</span>
        <span className="text-sm text-mist">per person</span>
      </div>
      <p className="mt-2 flex items-center gap-2 text-[12px] uppercase tracking-[0.2em] text-white/50">
        <Users size={13} className="text-gold" /> Min {p.minGuests} guests
      </p>
      <ul className="mt-6 grid flex-1 grid-cols-1 gap-x-6 gap-y-2 sm:grid-cols-2">
        {p.items.map((i) => (
          <li key={i} className="flex items-start gap-2 text-sm text-white/80">
            <Check size={13} className="mt-0.5 shrink-0 text-gold" /> {i}
          </li>
        ))}
      </ul>
      <p className="mt-6 border-t border-white/10 pt-4 text-xs leading-relaxed text-mist">{p.recommended}</p>
      <button
        onClick={() => pick(p)}
        data-testid={`book-package-${p.n}-button`}
        className={`mt-7 rounded-full py-3.5 text-[12px] font-semibold uppercase tracking-[0.2em] ${p.featured ? "btn-gold" : "btn-ghost text-white"}`}
      >
        Book Package {p.n}
      </button>
    </div>
  </FadeUp>
);

const CateringPackages = () => (
  <section id="packages" data-testid="catering-packages-section" className="mx-auto max-w-7xl px-5 py-32 md:px-10 md:py-40">
    <SectionHead
      index="05"
      kicker="Premium Tray Orders"
      title={<>Packages for <em className="italic text-gold">every celebration</em></>}
    />

    <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
      {PACKAGES.map((p, i) => <PackageCard key={p.n} p={p} delay={i * 0.12} />)}
    </div>

    <FadeUp delay={0.2} className="mt-10 flex flex-col items-center justify-between gap-6 rounded-2xl border border-white/10 bg-surface/40 p-7 md:flex-row md:p-8">
      <ul className="grid gap-2 text-sm text-mist sm:grid-cols-2 md:gap-x-10">
        {CATERING_NOTES.map((n) => (
          <li key={n} className="flex items-start gap-2">
            <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-gold" /> {n}
          </li>
        ))}
      </ul>
      <a
        href={`${API}/catering/menu.pdf`}
        data-testid="download-catering-pdf-button"
        className="btn-gold flex shrink-0 items-center gap-2 rounded-full px-7 py-4 text-[12px] font-semibold uppercase tracking-[0.18em]"
      >
        <Download size={15} /> Download Catering Menu
      </a>
    </FadeUp>
  </section>
);

export default CateringPackages;
